//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import copyright from "./components/copyright";
import about from "./components/about";
import history from "./components/history";
import honor from "./components/honor";
import information from "./components/information";
import logo from "./components/logo";
export default {
  name: "descriptionList",
  mixins: [loadMoreList],
  components: {
    copyright: copyright,
    about: about,
    history: history,
    honor: honor,
    information: information,
    logo: logo
  },
  data: function data() {
    return {
      pagingReqFn: "webDescriptions",
      pagingReqValue: "list"
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(data) {
      var _this = this;

      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'delWebDescriptions',
        data: {
          id: [data.id]
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};